import styled from 'styled-components';
import { breakpoints } from '../../constants/breakpoints';

export const PageContainer = styled.div`
  height: 100vh;
  box-sizing: border-box;
  padding: 32px 0;

  @media only screen and (max-width: ${breakpoints.smalldesktop}) {
    padding: 24px 0;
  }
`;
